<template lang="html">
  <label class="wrapping" :class="{'hasValue': hasValue, 'has-focus': focus}">
    <span class="input-label">{{ name }}:</span>
    <div class="input-wrapper" :class="lowName">
      <input :type="type" :placeholder="name" v-model="that" @focus="focusField" @blur="blurField">
    </div>
  </label>
</template>

<script>
export default {
  name: 'info-button',
  // props: {
  //   name: {
  //     type: String,
  //     required: true,
  //     default: "Field"
  //   }
  // },
  // props: ["value", "name"],
  props: {
    name: String,
    type: {
      type: String,
      default: 'text'
    },
    value: String
  },
  data() {
    return {
      focus: false
    }
  },
  methods: {
    updateVal() {
      this.$emit("input", this.value);
    },
    focusField() {
      this.focus = true
    },
    blurField() {
      this.focus = false
    }
  },
  computed: {
    that: {
      get() {
        return this.value || ""
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },
    hasValue() {

      return (this.that && this.that.length && this.that.length > 0)
    },
    lowName() {
      return this.name.toLowerCase() + "-wrapper"
    }
  }
}
</script>

<style lang="scss">

// Braintree Form styles
label.wrapping {

  transition: background-color 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95), color 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  // border-top: solid 1px #DEE2E5;
  border-bottom: solid 1px #DEE2E5;
  color: #6E787F;
  cursor: pointer;
  display: block;
  font-size: 16px;
  font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;

  // padding: 12px 14px;
  padding: 8px 12px;

  position: relative;
  // margin-top: -11px;
  margin: 0;
  width: 100%;
  text-align: left;
  z-index: 1;
  .input-label {
    transition: opacity 0.2s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    color: #999;
    display: block;
    // font-size: 12px;
    // margin-bottom: 4px;
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: 300;
    line-height: 1;

    opacity: 0;
  }
  .Card-Type {
    color: #6E787F;
    display: block;
    position: absolute;
    font-weight: bold;
    top: 12px;
    right: 14px;
    font-size: 12px;
    line-height: 1;
  }
  &.has-focus {
    background-color: #fff;
    cursor: text;
    z-index: 2;
    .input-wrapper:after { color: #393536; }
    .input-label { opacity: 1; }
  }
  &.hasValue, &:focus, &:active {
    .input-label { opacity: 1; }
  }


  .label {
    display: block;
    font-size: 16px;
    color: #6E787F;
    padding: 8px 12px;
    text-align: left;
  }

  input, select {
    background-color: transparent !important;
    display: block;
    border: none;
    color: #000;
    cursor: pointer;
    font-size: 16px;
    outline: none;
    line-height: 1;
    font-weight: 300;
    width: 100%;
    height: 20px;

    ::placeholder {
      color: #aaa;
      line-height: 1;
    }

    &:focus {
      ::placeholder { color: #999; }
    }

    &:-webkit-autofill, &::-webkit-autofill, &:autofill, &::autofill { background: inherit !important; }
    
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        transition: background-color 5000s ease-in-out 0s;
        -webkit-text-fill-color: blue !important;
    }
    
    // &[data-com.agilebits.onepassword.user-edited] { background: transparent !important; }

  }

  .input-wrapper {
    position: relative;
    background: inherit !important;
  }

  .input-wrapper iframe {
    height: 18px !important;
  }

  .amount-wrapper, .number-wrapper, .password-wrapper, .email-wrapper, .cvv-wrapper, .date-wrapper {
    input, iframe, select {
      transition: transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.2s ease;
      transform: translateX(-23px);
      padding: 0 23px;
    }
    &:after {
      transition: opacity 0.2s ease;
      transform: translateY(-50%);
      color: #393536;
      display: inline-block;
      line-height: 1;
      left: 0px;
      opacity: 0;
      position: absolute;
      // top: 50%;
      top: 11px;
      font-size: 120%;

      font-family: 'icomoon' !important;
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      // make icons a bit smaller
      font-size: 90%;

      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      // make icons thinner in webkit (white icons on dark background)
      text-shadow: 0 0 0 rgba(0,0,0,.01);
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizelegibility;
    }
  }
  .password-wrapper:after { content: "\e98e"; }
  .email-wrapper:after {    content: "\ea84"; }


  // active state
  &.has-focus, &.has-value {
    .amount-wrapper, .number-wrapper, .password-wrapper, .email-wrapper, .cvv-wrapper, .date-wrapper {
      input, iframe, select {
        transform: translateX(0);
      }
      &:after { opacity: 1; }
    }
  }



}

label.wrapping + label.wrapping { border-top: none; }

</style>
